export interface PartnerOffering {
  id: string;
  name: string;
  slug: string;
  offeringTitle?: string;
  description: string;
  template: Template;
  partnerId: string;
  promoCodeBoxContent?: string;
  generalInfo?: string;
  spaceIds: string[];
  addOnIds: string[];
  lastUpdated: Date;
  faqs?: string;
}

export interface SpaceOffering {
  id: string;
  name: string;
  description: string;
  price: number;
  addOnID: string;
  spaceID: string;

  displayName?: string;
  numberOfEntries?: number;
  daysToExpire?: number;
}

export enum Template {
  DayPass = "day_pass",
  MultiPass = "multi_pass",
  AddOn = "add_on",
  DailyAccess = "daily_access",
  DayOfficeMultiPass = "day_office_multi_pass",
  DayOffice = "day_office",
  MeetingRoom = "meeting_room",
  SnowflakeDayOfficeListing = "snowflake_day_office_listing",
  SnowflakeDayOffice = "snowflake_day_office",

  // V2 templates
  DailyOffice = "daily_office",
  DailyAccessV2 = "daily_access_v2",
  MeetingRoomV2 = "meeting_room_v2",
  AddOnV2 = "add_on_v2",
  EventSpaceV2 = "event_space_v2",
  RoomGalleryV2 = "room_gallery_v2",
}

export enum CatalogType {
  DailyAccess = "daily_access",
  MeetingRooms = "meeting_room",
  DailyOffice = "daily_office",
  EventSpace = "event_space",
  RoomGallery = "room_gallery",
  NotSupport = "not_support",
}

export function getCatalogTypeByTemplate(template?: string) {
  switch (template) {
    case Template.DailyAccess:
    case Template.DailyAccessV2:
    case Template.DayPass:
      return CatalogType.DailyAccess;
    case Template.DayOffice:
    case Template.DailyOffice:
    case Template.SnowflakeDayOffice:
      return CatalogType.DailyOffice;
    case Template.MeetingRoom:
    case Template.MeetingRoomV2:
      return CatalogType.MeetingRooms;
    case Template.EventSpaceV2:
      return CatalogType.EventSpace;
    case Template.RoomGalleryV2:
      return CatalogType.RoomGallery;
    default:
      return CatalogType.NotSupport;
  }
}

export function toPartnerOffering(data: any): PartnerOffering {
  return {
    id: data.id,
    name: data.name,
    slug: data.slug,
    offeringTitle: data.offering_title,
    description: data.description,
    template: data.template,
    partnerId: data.partner_id,
    promoCodeBoxContent: data.promo_code_box_content,
    generalInfo: data.general_info,
    spaceIds: data.space_ids,
    addOnIds: data.add_on_ids,
    lastUpdated: new Date(data.updated_at * 1000),
    faqs: data.faqs,
  };
}

export function toSpaceOffering(data: any): SpaceOffering {
  return {
    id: data.id,
    name: data.name,
    description: data.description,
    displayName: data.display_name,
    price: data.price,
    numberOfEntries: data.number_of_entries,
    daysToExpire: data.days_to_expire,
    spaceID: data.space_id,
    addOnID: data.add_on_id,
  };
}

export function calculateDiscountPercentage(
  multiPass: SpaceOffering,
  singlePass?: SpaceOffering
): number {
  if (!singlePass) return 0;

  if (singlePass.addOnID === multiPass.addOnID) {
    return 0;
  }
  if (!multiPass.numberOfEntries) return 0;

  const originPrice = multiPass.numberOfEntries * singlePass.price;
  const discountedPrice = multiPass.price;
  const discountValue = (originPrice - discountedPrice) / originPrice;

  return Math.round(discountValue * 100);
}
